import { render, staticRenderFns } from "./RequestClarifications.vue?vue&type=template&id=6410d5e2&"
import script from "./RequestClarifications.vue?vue&type=script&lang=js&"
export * from "./RequestClarifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports